import { Component } from "react";
import { connect } from "react-redux";
import { pingBackend } from "../../actions/heartbeat";

const PING_INTERVAL = 5 * 60 * 1000; // 5 minutes

class HeartBeat extends Component {
  lastPing = Date.now();

  handleActivity = () => {
    let now = Date.now()
    if (now - this.lastPing >= PING_INTERVAL) {
      this.props.dispatch(pingBackend())
      this.lastPing = now
    }
  };

  componentDidMount() {
    window.addEventListener("mousedown", this.handleActivity);
    window.addEventListener("keydown", this.handleActivity);
  }

  componentWillUnmount() {
    window.removeEventListener("mousedown", this.handleActivity);
    window.removeEventListener("keydown", this.handleActivity);
  }

  render() {
    return null;
  }
}

export default connect()(HeartBeat);
